import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Col, Row } from 'react-bootstrap';
import { FormActions, DateTimeInput, Input, Select } from '../../common/components/formControls';
import { withTranslation } from 'react-i18next';
import utils from '../../common/services/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, onReset, pristine, loading, t, onSubmit, formStatusTypes }) => {
	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit}>
					<Row>
						<Col sm={6}>
							<Field name='parentName' component={Input} type='text' label={t('SelfAssessments_Parent')} />
						</Col>
						<Col sm={6}>
							<Field name='childName' component={Input} type='text' label={t('SelfAssessments_Child')} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Select name='status' label={t('SelfAssessments_Status')} data={formStatusTypes} />
						</Col>
						<Col sm={3}>
							<Field name='dateFrom' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodFrom()} placeholder={t('Common_From')} label={t('SelfAssessments_Period')} />
						</Col>
						<Col sm={3}>
							<Field name='dateTo' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodTo()} placeholder={t('Common_To')} label='&nbsp;' />
						</Col>
					</Row>
					<FormActions>
						<Button onClick={handleSubmit(values => onSubmit({ ...values }))} disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<Button disabled={pristine || loading} onClick={onReset}>{t('Common_Reset')}</Button>
					</FormActions>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'selfAssessmentsFilter' })(withTranslation()(Filter));